module.exports = __webpack_public_path__ + "static/media/trainingPatienceIcon.9a0fd079.png";